import { render, staticRenderFns } from "./SimpleLabeledSelect.vue?vue&type=template&id=43dd80e2"
import script from "./SimpleLabeledSelect.vue?vue&type=script&lang=ts"
export * from "./SimpleLabeledSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports